<template>
  <div class="bg-container page">
    <img src="img/login/login-bg.png" class="bg-img">
    <div class="bg-wrapper">
      <div class="register">
        <div class="nav-bar van-nav-bar van-hairline--bottom">
          <div class="van-nav-bar__content">
            <div class="van-nav-bar__left" @click="back()">
              <i class="van-icon van-icon-arrow-left" style="color: rgb(255, 255, 255);"></i>
            </div>
            <div class="van-nav-bar__title van-ellipsis"></div>
          </div>
        </div>
        <div class="wrapper">
          <div class="logo-container">
            <div class="logo-wrapper">
              <img :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'" class="logo-img">
            </div>
          </div>
          <div class="loginForm">
            <div class="input van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input type="text" v-model="username" :placeholder="$t('register.username')" class="van-field__control">
                </div>
              </div>
            </div>
            <div class="input van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input v-model="password"  :placeholder="$t('register.password')" :type="passwordType" autocomplete="" class="van-field__control">
                  <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="switchPasswordType"/>
                </div>
              </div>
            </div>
            <div class="input van-cell van-field">
              <div class="van-cell__value van-cell__value--alone van-field__value">
                <div class="van-field__body">
                  <input type="text"  v-model="code"  :placeholder="$t('register.code')" class="van-field__control">
                </div>
              </div>
            </div>
            <div class="agreement">

              <van-checkbox v-model="checked" />
              <span class="agreement-text">{{ $t("register.agreement") }}</span>
            </div>
            <button class="login-btn van-button van-button--primary van-button--normal" @click="doRegister">
              <div class="van-button__content"><span class="van-button__text">{{ $t("register.doRegister") }}</span></div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      password: this.inputValue,
      passwordType: 'password',
    };
  },
  methods: {
    toLogin() {
      this.$router.push("Login")
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    back() {
      this.$router.push("/")
    },
    doRegister() {
      if (this.username === "" || this.username === null || this.username === undefined) {
        console.log(this.$t('login.username'));
        this.$toast.fail(this.$t('login.username'));
        return false;
      }
      if (this.password === "" || this.password === null || this.password === undefined) {
        this.$toast.fail(this.$t('login.password'));
        return false;
      }
      if (this.code === "" || this.code === null || this.code === undefined) {
        this.$toast.fail(this.$t('register.code'));
        return false;
      }
      if (!this.checked) {
        this.$toast.fail(this.$t('register.chooseAgreement'));
        return false;
      }
      this.$http({
        method: 'get',
        data: {
          username: this.username,
          password: this.password,
          code: this.code
        },
        url: 'member_register'
      }).then(res => {
        if (res.code === 200) {
          this.$toast.success(this.$t("msg." + res.msg));
          localStorage.setItem('token', res.data)
          this.$router.push("Mine")
        } else {
          this.$toast.fail(this.$t("msg." + res.msg));
        }
      })
    }
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.agreement {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agreement .agreement-text {
  margin-left: 10PX;
  color: #fff;
  font-weight: 500;
  line-height: 30PX;
}

::v-deep .agreement .van-icon {
  font-size: 30px;
}

::v-deep .agreement .van-checkbox__icon {
  width: 70px;
  font-size: 38px;
}

::v-deep .agreement .van-checkbox__icon--checked .van-icon {
  color: #fff;
  border-color: rgb(244, 49, 127);
  background-color: rgb(244, 49, 127);
}
</style>
